import React, { useState, useEffect } from "react";
import useHttpRequests from "../../../hooks/useHttpRequests";
import { TableWithStickyHeader } from "../../uiControls/tableWithStickyHeader";
import { UserAdd } from "./userAdd";
import { UserUpdate } from "./userUpdate";
import { AddNew } from "../../uiControls/addNew";
import * as utils from "../../common/utils";
import { ConfirmationDialog } from "../../common/confirmationDialog";

const userColumns = [
  { label: "User (Brief)", keyField: "userKey", dataField: "userName" },
  {
    label: "Name",
    keyField: "userKey",
    dataField: "name",
  },
  {
    label: "Role Type",
    keyField: "userKey",
    dataField: "role",
  },
  {
    label: "Status",
    keyField: "userKey",
    dataField: "active",
    minWidth: 20,
    maxWidth: 20,
  },
  {
    label: "",
    keyField: "userKey",
    dataField: "userKey",
    minWidth: 20,
    maxWidth: 20,
  },
];

const userSearchColumns = ["userName", "name", "role"];

export const UserConfig = () => {
  const [updateOpen, setUpdateOpen] = useState(false);
  const [updateOpenType, setUpdateOpenType] = useState("");
  const [roles, setRoles] = useState([]);
  const [userAttributes, setUserAttributes] = useState({
    userKey: 0,
    userName: "",
    name: "",
    role: "",
    active: true,
  });

  const [dialogOpen, setDialogOpen] = useState(false);
  const [confirmationDialogAttributes, setConfirmationDialogAttributes] =
    useState({});

  const { sendRequest: fetchRoles } = useHttpRequests();
  const { sendRequest: fetchUserDetails } = useHttpRequests();

  const userEditHandler = (e, key) => {
    e.stopPropagation();
    if (updateOpen) {
      return false;
    }

    const getUserDetails = (userObj) => {
      if (!userObj || !userObj.isSuccess || userObj.errorResponse) {
        console.log("User fetch response returns error");
        return;
      }

      setUserAttributes({
        userKey: userObj["user"]["userKey"],
        userBrief: userObj["user"]["userName"],
        name: userObj["user"]["lastName"] + ", " + userObj["user"]["firstName"],
        email: userObj["user"]["email"],
        roleKey: userObj["user"]["roleKey"],
        roleTitle: utils.findStringById(
          roles,
          "id",
          userObj["user"]["roleKey"]
        ),
        active: userObj["user"]["active"],
      });

      setUpdateOpen(true);
      setUpdateOpenType("edit");
    };

    fetchUserDetails(
      { url: "Users/" + key, method: "GET", header: true },
      getUserDetails
    );
  };

  const changeUserStatus = (e, key, status, name) => {
    e.stopPropagation();
    setConfirmationDialogAttributes({
      title: "User status change confirmation!",
      message:
        "Are you sure to mark " +
        (status ? "active" : "inactive") +
        " the " +
        name +
        "?",
      confirmText: "Yes",
      cancelText: "No",
      url: "Users/",
      keyField: "userId",
      key: key,
      status: status,
      messageTitle: name,
    });
    setDialogOpen(true);
  };

  const getUrl = (params) => {
    return "Users?" + params + "&isAdd=false";
  };

  useEffect(() => {
    const getRoleResponse = (roleObj) => {
      if (!roleObj || !roleObj.isSuccess || roleObj.errorResponse) {
        console.log("Role fetch response returns error");
        return;
      }
      setRoles(
        roleObj["roles"]?.map((t) => {
          return { id: t["roleKey"], label: t["name"] };
        })
      );
    };

    fetchRoles(
      { url: "Roles/Active", method: "GET", header: true },
      getRoleResponse
    );
  }, []);

  const userDetailProps = {
    roles,
    setUpdateOpen,
    userAttributes,
  };

  return (
    <div
      style={{
        display: "flex",
        flexFlow: "column",
        height: "calc(100vh - 160px)",
      }}
    >
      <ConfirmationDialog
        open={dialogOpen}
        setDialogOpen={setDialogOpen}
        confirmationDialogAttributes={confirmationDialogAttributes}
      />
      <div
        style={{
          display: "flex",
          flexFlow: "column",
          gap: "20px",
          width: "100%",
        }}
      >
        {!updateOpen && (
          <>
            <TableWithStickyHeader
              title=""
              pagging={true}
              columns={userColumns}
              url={getUrl}
              sourceObj="users"
              editHandler={userEditHandler}
              updateOpen={updateOpen || dialogOpen}
              searchOnColumns={userSearchColumns}
              changeStatus={changeUserStatus}
              searchPlace="right"
            />
            <AddNew
              onClickCall={() => {
                setUserAttributes({
                  userKey: 0,
                  name: "",
                  description: "",
                  active: true,
                  defaultMenu: 0,
                  defaultMenuTitle: "",
                  menuList: [],
                });
                setUpdateOpen(true);
                setUpdateOpenType("add");
              }}
            />
          </>
        )}
      </div>

      {updateOpen && updateOpenType === "add" && (
        <div
          style={{
            display: "flex",
            width: "100%",
          }}
        >
          <UserAdd {...userDetailProps} />
        </div>
      )}
      {updateOpen && updateOpenType === "edit" && (
        <div
          style={{
            display: "flex",
            width: window.innerWidth <= 1366 ? "100%" : "65%",
          }}
        >
          {<UserUpdate {...userDetailProps} />}
        </div>
      )}
    </div>
  );
};
